<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.prestation',1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-container>
                    <b-row class="mb-2">
                        <b-col
                            sm="12"
                            class="text-right"
                            v-if="can"
                        >
                            <b-button variant="primary" class="btn-sm" @click="updatePrestation">
                                {{ $t('message.edit') }}
                            </b-button>
                            <b-button variant="danger" class="btn-sm" v-b-modal.delete-modal>
                                {{ $t('message.delete') }}
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.prestation',1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mPrestation.nom }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deletePrestation">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </b-container>
                <b-container>
                    <!--<h3 class="heading text-center mt-3 mb-3">{{$t('message.infoGenerale')}}</h3>-->


                      <div class="row justify-content-center">
                        <div class="col-8">
                            <div class="timeline-box h-100">
                                <div class="box-title">
                                    <i class="fa fa-list" aria-hidden="true"></i>
                                    {{ $t('message.detailsPrestation') }}
                                </div>
                                <div class="box-content">
                                    <div class="box-item column-display-style column-display-style-without-mb">
                                        <div class="row">
                                            <div class="col-6 text-right">
                                                <p><strong>{{ $t('message.nomDeLaCategorie') }}</strong></p>
                                            </div>
                                            <div class="col-6 text-left">
                                                <p>{{mPrestation.categorie == null ? $t('message.nonDefinie'): mPrestation.categorie.nom  }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6 text-right">
                                                <p><strong>{{ $t('message.name') }}</strong></p>
                                            </div>
                                            <div class="col-6 text-left">
                                                <p>{{ mPrestation.nom }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6 text-right">
                                                <p><strong>{{ $t('message.price') }}</strong></p>
                                            </div>
                                            <div class="col-6 text-left">
                                                <p>{{ _displayNumber(mPrestation.prix) }}</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="box-footer">
                                </div>
                            </div>
                        </div>
                      </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
	import { displayNumber } from "../../helpers/general";

    export default {
        name: "Show",
        computed: {
            ...mapGetters(["prestation", 'hasAdminRole',
                'hasGestionnaireRole', 'hasMedecinControleRole','isComptable','hasAssistante']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
            },

            mPrestation:function () {
                return this.prestation;
            }
        },

        data() {
            return {
                prestation_id: this.$route.params.prestation,
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [10, 15, 20]
                },
            }
        },

        methods: {
            updatePrestation(){
                this.$router.push({ name: 'edit-prestation', params: { prestation: this.prestation_id } });
            },

            getPrestation() {
                let args = {
                    prestation: this.prestation_id,
                };
                this.$store.dispatch("getPrestation", {args});
            },

            deletePrestation(){
                let args = {
                    prestation: this.prestation_id,
                };

                let successMessage = this.$i18n.t('message.prestationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deletePrestation', {args, successMessage, errorMessages})
            },

			_displayNumber: displayNumber,
        },
        mounted() {
            this.getPrestation();
        }
    }
</script>

<style scoped lang="scss">
    $primary-color: #2dcecc;

    p {
        font-size: 0.9rem !important;
    }

    .timeline-box {
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2) !important;
        .box-title {
            i {
                color: $primary-color !important;
            }
        }
    }
</style>
